import { PolicyActionEnum } from '../actions.js';
import { defineBuiltinPolicy } from './types.js';

export const managementAppAdminPolicy = defineBuiltinPolicy({
  key: 'builtin:management-app-admin',
  name: 'Management App Admin',
  description: 'Full access to the management app.',
  actions: [
    PolicyActionEnum.ConsoleAccess,
    PolicyActionEnum.AccountView,
    PolicyActionEnum.AccountManage,
    PolicyActionEnum.AgentView,
    PolicyActionEnum.AgentManage,
    PolicyActionEnum.ApplicationView,
    PolicyActionEnum.ApplicationManage,
    PolicyActionEnum.AuditLogView,
    PolicyActionEnum.AuthAppView,
    PolicyActionEnum.AuthAppManage,
    PolicyActionEnum.BrandView,
    PolicyActionEnum.BrandManage,
    PolicyActionEnum.ChatContextView,
    PolicyActionEnum.ChatContextManage,
    PolicyActionEnum.ConnectedAppView,
    PolicyActionEnum.ConnectedAppManage,
    PolicyActionEnum.CrmConnectionView,
    PolicyActionEnum.CrmConnectionManage,
    PolicyActionEnum.DashboardView,
    PolicyActionEnum.DashboardManage,
    PolicyActionEnum.DataConnectionView,
    PolicyActionEnum.DataConnectionManage,
    PolicyActionEnum.DataSourceView,
    PolicyActionEnum.DataSourceManage,
    PolicyActionEnum.FilterView,
    PolicyActionEnum.FilterManage,
    PolicyActionEnum.FormView,
    PolicyActionEnum.FormManage,
    PolicyActionEnum.PolicyView,
    PolicyActionEnum.PolicyManage,
    PolicyActionEnum.PolicyGrantAny,
    PolicyActionEnum.PromptView,
    PolicyActionEnum.PromptManage,
    PolicyActionEnum.PromptQueryLogView,
    PolicyActionEnum.RoleView,
    PolicyActionEnum.RoleManage,
    PolicyActionEnum.SecretView,
    PolicyActionEnum.SecretManage,
    PolicyActionEnum.ToolView,
    PolicyActionEnum.ToolManage,
    PolicyActionEnum.UnmetNeedView,
    PolicyActionEnum.UnmetNeedManage,
    PolicyActionEnum.UserView,
    PolicyActionEnum.UserManage,
    PolicyActionEnum.UserAssign,
    PolicyActionEnum.ChatHcpViewAll,
  ],
});
